<template>
    <div v-if="isLoaded">
        
        <div class="ms-3 mt-0 test" v-on:click="backRoute()"  v-if="!showAnagrafica">
            <a class="bi bi-arrow-left-circle-fill fs-2"></a>
        </div>
        <div class="ms-3 mt-0 test" v-on:click="showAnagrafica=false"  v-else>
            <a class="bi bi-arrow-left-circle-fill fs-2"></a>
        </div>


        <div class="container text-center col-lg-6" v-if="!showAnagrafica">
            
            <div class="row mt-3 mb-3">
                <div class="col-auto mx-auto border rounded-3 bgAlma">
                    <p class="fw-bold mb-0 text-center text-white">
                        <i class="bi bi-person-fill text-white"></i> {{ $store.state.nomeGiurato }}
                        <i class="bi bi bi-grip-vertical text-white"></i> TAV. {{ $store.state.tavoloGiurato }}
                    </p>
                </div>
            </div>
            <div class="mb-4">
                <h1 class="fw-light">Esame di <span class="fw-bold">{{ name }}</span> <i class="bi bi-info-circle-fill" @click="viewAnagrafica()"></i></h1>
            </div>
            
            <div>
                <div class="col">
                    <h4 class="fw-bold mb-2 text-start">Indicatori</h4>
                </div>
                <div><ol>
                    <li class="text-start" v-for="i in indicatori" v-bind:key="i.Id">{{ i.Descrizione__c }}</li>
                </ol></div>
            </div>
            
            <!-- TABELLA CON INDICATORI ESAME -->
            <div>
                <div v-for="i in indicatoriEsame" v-bind:key="i.Id">
                    <div>
                        <div class="col">
                            <votoEsame :indicatore="i" :voto="esame.indicatoriEsame[i.Descrizione__c]" :commento="esame.commentiIndicatoriEsame[i.Descrizione__c]"
                            @saveVotiIndicatoriEsame="saveVotiIndicatoriEsame($event)"></votoEsame>
                        </div>
                    </div>
                </div>
                
                <div v-if="indicatoriPiatti.length">
                    <div v-for="piatto of piatti" v-bind:key="piatto.Id">
                        <div class="d-flex">
                            <div class="col">
                                <votoPiatto :piatto="piatto" :indicatori="indicatori" @saveVotiPiatto="saveVotiPiatto($event)"></votoPiatto>
                            </div>
                            <div class="ms-1 align-content-end">
                                <table class="table table-bordered border-secondary" :class="{'bg-dark bg-opacity-10' : !piatto.Ordine_di_uscita__c}">
                                    <tbody>
                                        <tr><th :class="{'bgAlma text-white' : piatto.Ordine_di_uscita__c}" scope="col">Media</th></tr>
                                        <tr>
                                            <td :class="{'fw-bold bg-danger bg-opacity-25' : piatto.media < 18 && piatto.Ordine_di_uscita__c}">
                                                {{ piatto.media }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-for="i in indicatoriOpzionali" v-bind:key="i.Id">
                    <div v-if="i.Tipo__c == 'Esame' && i.Opzionale__c">
                        <div class="col">
                            <votoEsame :indicatore="i" :voto="esame.indicatoriEsame[i.Descrizione__c]" :commento="esame.commentiIndicatoriEsame[i.Descrizione__c]"
                            @saveVotiIndicatoriEsame="saveVotiIndicatoriEsame($event)"></votoEsame>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- MEDIA CON VOTO FINALE -->
            <div class="d-flex mb-3">
                <div class="col pe-0">
                    <h4 class="fw-bold py-2 rounded-start bgAlma text-white">Media totale</h4>
                </div>
                <div class="col-2 col-lg-1 col-md-1 ps-0 pe-0" style="width: 25%;text-align: right;">
                    <h4 class="fw-bold py-2 rounded-end align-content-center bgAlma text-white" style="padding-right:5px;">{{ mediaTotale + punti}}</h4>
                </div>
            </div>

            
            
        </div>
        <anagraficaStudente v-if="showAnagrafica" :studenteIds="studenteIds" :nome="nomeStudente"></anagraficaStudente>
    </div>
    
</template>


<script>
import { create, all } from "mathjs";
const math = create(all);
import votoEsame from '../components/votoEsame.vue'
import votoPiatto from '../components/votoPiatto.vue'
import anagraficaStudente from '../components/anagraficaStudente.vue'

export default {
    name: 'visualizzaEsame',
    components: {
        votoEsame, votoPiatto, anagraficaStudente
    },
    data() {
        return {
            mediaIndicatoriEsame: 0,
            mediaTotale: 0,
            mTipoVoto: new Map(),
            punti: 0,
            name: "",
            piatti: [],
            esame: {},
            colspan: "",
            numVotiPiatto: "",
            numVotiEsame: "",
            numVotiOpzionali: "",
            indicatori: [],
            uscitaPiatti: [],
            qtaVotiEsame: [],
            prenotIds: [],
            mVotiEsami: new Map(),
            interval: null,
            cache: [],
            showAnagrafica: false,
            studenteIds: {},
            isLoaded: false,
            
        }
    },
    watch: {
        indicatori: {
            immediate: true,
            handler(newIndicatori) {
                if (newIndicatori.length > 0 && this.esame) {
                    // Ri-inizializza gli indicatori dell'esame
                    this.esame.indicatoriEsame = {};
                    this.esame.commentiIndicatoriEsame = {};
                    newIndicatori.forEach(i => {
                        if (i.Tipo__c === 'Esame') {
                            this.esame.indicatoriEsame[i.Descrizione__c] = -1;
                            this.esame.commentiIndicatoriEsame[i.Descrizione__c] = '';
                        }
                    });
                }
            }
        }
    },
    computed: {
        indicatoriEsame() {
            return this.indicatori.filter(i => i.Tipo__c === 'Esame' && !i.Opzionale__c);
        },
        indicatoriOpzionali() {
            return this.indicatori.filter(i => i.Tipo__c === 'Esame' && i.Opzionale__c);
        },
        indicatoriPiatti() {
            return this.indicatori.filter(i => i.Tipo__c === 'Piatto');
        }
    },
    created () {
        this.initializeView()
    },
    methods: {
        async initializeView(){
            console.log('mounted di visualizzaEsame.vue')
            this.$store.commit('GET_GIURATO')
            
            this.cache = this.$route.params.data.split('-');
            // console.log("testing passage of id: ", this.cache);
            this.name = this.cache[1];
            
            await this.getPiattiEdEsami();
            await this.getEsame(this.cache[0]);
            
            // console.log('data: ', this.$data)
            console.log('this.esame',this.esame)
            console.log('this.esame.votiEsame', this.esame.votiEsame)
            
            if(this.esame.votiEsame && this.esame.votiEsame.length > 0) {
                console.log(this.esame.votiEsame)
                for(var votoEsame of this.esame.votiEsame) {
                    console.log(votoEsame.Piatto__c, "test passaggio piatto")
                    if(votoEsame.Piatto__c) this.mTipoVoto.set(votoEsame.Tipo__c + votoEsame.Piatto__c, votoEsame.Id)
                    else this.mTipoVoto.set(votoEsame.Tipo__c, votoEsame.Id)
                    if(votoEsame.Piatto__c) {
                        this.saveVotiPiatto({   
                            indicatore: votoEsame.Tipo__c, voto: votoEsame.Voto__c, 
                            idPiatto: votoEsame.Piatto__c, commento: votoEsame.Commento__c, lettura: true
                        })
                    } else this.saveVotiIndicatoriEsame(
                    {   indicatore: votoEsame.Tipo__c, voto: votoEsame.Voto__c, 
                        commento: votoEsame.Commento__c, lettura: true
                    }
                    )
                }
            }
            this.isLoaded=true;
        },
        viewAnagrafica(){
            console.log('showAnagrafica')
            // var p = {
            //     Opportunita__c: this.esame.Opportunita__c,
            //     Account__c: this.esame.Opportunita__r.AccountId,
            //     Account__r: { Name: this.name }
            // }
            // console.log(p)
            // this.$emit('setStudenteAnagrafica', p)
            this.showAnagrafica = true
            this.valutaEsame = false
            this.studenteIds = {
                opptyId: this.esame.Opportunita__c,
                accountId: this.esame.Opportunita__r.AccountId
            }
            this.nomeStudente = this.name
        },
        saveVotiPiatto({indicatore, voto, idPiatto, commento, lettura}) {
            console.log('indicatore', indicatore)
            console.log('voto', voto, typeof(voto))
            console.log('idPiatto', idPiatto)
            //!!!!
            var statoPiatto = ''
            for(var piatto of this.piatti) {
                if(piatto.Id == idPiatto) {
                    console.log('piatto', piatto)
                    piatto.voti[indicatore] = Number(voto)
                    piatto.commenti[indicatore] = commento
                    
                    statoPiatto = piatto.Stato__c
                    
                    piatto.media = this.calcolaVotoFinale(piatto.voti, 'Piatto')
                }
                console.log(piatto.voti)
            }
            
            if(!lettura) {
                var votoEsame = {
                    Name: this.esame.Name +' - '+ this.$store.state.userprofile.Name,
                    Docente__c : this.$store.state.userprofile.Id,
                    Esame_Individuale__c : this.esame.Id,
                    Piatto__c : idPiatto,
                    Tipo__c : indicatore,
                    Voto__c : Number(voto)
                }
                console.log('votoEsame',votoEsame)
                if(this.mTipoVoto.has(votoEsame.Tipo__c + votoEsame.Piatto__c)) votoEsame['Id'] = this.mTipoVoto.get(votoEsame.Tipo__c + votoEsame.Piatto__c)
                
                if(votoEsame.Voto__c < 18) votoEsame['Commento__c'] = commento
                else votoEsame['Commento__c'] = ''
                if(this.$store.state.nomeGiurato != '') {
                    votoEsame.Name = this.esame.Name +' - '+ this.$store.state.nomeGiurato
                    votoEsame['Giurato__c'] = this.$store.state.nomeGiurato
                }
                
                this.$store.dispatch('saveVotoEsame', {votoEsame: votoEsame})
                .then(resp => {
                    console.log('saveVotoEsame resp',resp)
                    this.mTipoVoto.set(resp.Tipo__c + resp.Piatto__c, resp.Id)
                })
                
                if(statoPiatto != 'Valutato') {
                    var data = { Id: idPiatto, Stato__c: 'Valutato' }
                    this.$store.dispatch('updateStatoPiatto', data)
                    .then( resp => { console.log(resp) })
                }
            }
            
            this.calcolaMediaTotale()
        },
        saveVotiIndicatoriEsame({indicatore, voto, commento, lettura}) {
            this.esame.indicatoriEsame[indicatore] = Number(voto)
            this.esame.commentiIndicatoriEsame[indicatore] = commento
            
            this.esame.mediaIndicatoriEsame = this.calcolaVotoFinale(this.esame.indicatoriEsame, 'Esame')
            
            if(!lettura) {
                var votoEsame = {
                    Name: this.esame.Name +' - '+ this.$store.state.userprofile.Name,
                    Docente__c : this.$store.state.userprofile.Id,
                    Esame_Individuale__c : this.esame.Id,
                    Tipo__c : indicatore,
                    Voto__c : Number(voto)
                }
                
                if(this.mTipoVoto.has(votoEsame.Tipo__c)) votoEsame['Id'] = this.mTipoVoto.get(votoEsame.Tipo__c)
                
                if(votoEsame.Voto__c < 18) votoEsame['Commento__c'] = commento
                else votoEsame['Commento__c'] = ''
                if(this.$store.state.nomeGiurato != '') {
                    votoEsame.Name = this.esame.Name +' - '+ this.$store.state.nomeGiurato
                    votoEsame['Giurato__c'] = this.$store.state.nomeGiurato
                }
                
                this.$store.dispatch('saveVotoEsame', {votoEsame: votoEsame})
                .then(resp => {
                    console.log('saveVotoEsame resp',resp)
                    this.mTipoVoto.set(resp.Tipo__c, resp.Id)
                })
            }
            
            this.calcolaMediaTotale()
        },
        calcolaMediaTotale() {
            var listaMedieEsame = []
            for(var piatto of this.piatti) {
                listaMedieEsame.push(piatto.media)
            }
            this.esame.mediaTotale = math.round(math.mean(listaMedieEsame),2) 
            if(this.esame.mediaIndicatoriEsame)this.esame.mediaTotale+=this.esame.mediaIndicatoriEsame;
            console.log("media totale: ", this.esame.mediaTotale, listaMedieEsame, this.esame.mediaIndicatoriEsame)
            this.mediaTotale = this.esame.mediaTotale
        },
        calcolaVotoFinale(voti, tipo) {
            console.log('--> calcolaVotoFinale', voti)
            var listaVoti = []
            var punti = 0
            for(var i of this.indicatori) {
                if(i.Tipo__c == tipo) {
                    var voto = voti[i.Descrizione__c]
                    if(i.Calcolo_valutazione__c == 'Media Aritmetica') {
                        if(voto && voto >= 0) listaVoti.push(voto)
                        else listaVoti.push(0)
                    }
                    if(i.Calcolo_valutazione__c == 'Punti aggiuntivi') punti += voto
                }
            }
            if(listaVoti.length > 0 && tipo == 'Piatto') return (math.round(math.mean(listaVoti),2)) + punti
            
            if(punti && tipo == 'Esame') this.punti = punti
            if(listaVoti.length > 0 && tipo == 'Esame') return math.round(math.mean(listaVoti),2)
            
            return 0
        },
        async getPiattiEdEsami() {
            try {
                const data = { numTavolo: this.$store.state.tavoloGiurato };
                const [esamiResp, piattiResp] = await Promise.all([
                this.$store.dispatch('getListaEsami', data),
                this.$store.dispatch('getPiattiPerEsame', data)
                ]);
                
                this.esami = esamiResp;
                this.uscitaPiatti = piattiResp;
                console.log(this.uscitaPiatti, "testing uscitaPiatti")
                
                const condizioniResp = await this.$store.dispatch('getCondizioniEsame', this.esami[0].Opportunita__r.Edizione_Corso__r.Corso__c);
                console.log("condizioni esame: ", condizioniResp);
                this.prenotIds = this.esami.map(e => e.Prenotazione__c);
                Object.assign(this, {
                    numVotiPiatto: condizioniResp.numVotiPiatto,
                    numVotiEsame: condizioniResp.numVotiEsame,
                    numVotiTot: condizioniResp.numVotiTot,
                    numVotiOpzionali: condizioniResp.numVotiOpzionali,
                    indicatori: condizioniResp.indicatori
                });
                
                await this.getQtaVotiEsami();
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        getQtaVotiEsami() {
            
            var data = {
                prenotazioni: this.prenotIds,
                idDocente: this.$store.state.userprofile.Id, 
                nomeGiurato: this.$store.state.nomeGiurato
            }
            console.log("analisi QTA: ", data);
            this.$store.dispatch('getQtaVoti', data)
            .then(resp => {
                if(resp != null && resp.qtaVotiEsami != null) {
                    this.qtaVotiEsame = resp.qtaVotiEsami
                    for(var qve of this.qtaVotiEsame) {
                        
                        // controlla voti x piatto
                        if(qve.votiDati == this.numVotiPiatto) this.mVotiEsami.set(qve.Piatto__c, true)
                        else this.mVotiEsami.set(qve.Piatto__c, false)
                    }
                }
                
                var up = []
                this.uscitaPiatti.forEach( p => {
                    if(p.valutata == null) p['valutata'] = false
                    if(this.mVotiEsami.get(p.Id)) p.valutata = true
                    up.push(p)
                })
                this.uscitaPiatti = up
            })
        },
        async getEsame(record) {
            try {
                console.log("starting getEsame: ", record);
                const idPrenotazione = record;
                const esame = await this.$store.dispatch('getEsame', idPrenotazione);
                
                if (!esame) {
                    console.log('Esame non trovato');
                    return;
                }
                
                if (!this.indicatori || this.indicatori.length === 0) {
                    await this.getPiattiEdEsami(); // Ricarica gli indicatori se mancano
                }
                
                console.log("testing indicatori getEsame: ", this.indicatori)
                esame.indicatoriEsame = {};
                esame.commentiIndicatoriEsame = {};
                this.indicatori.forEach(i => {
                    if (i.Tipo__c === 'Esame') {
                        esame.indicatoriEsame[i.Descrizione__c] = -1;
                        esame.commentiIndicatoriEsame[i.Descrizione__c] = '';
                    }
                });
                
                esame['votiEsame'] = []
                if(esame.Voti_Esami__r && esame.Voti_Esami__r.records) esame.votiEsame = esame.Voti_Esami__r.records
                
                console.log("esame piatto: ", esame)
                const piatti = await this.$store.dispatch('getPiattiStudente', { idTesi: esame.Tesi__c });
                console.log("piatti appena popolati: ", piatti)
                for(var piatto of piatti) {
                    var voti = {}
                    var commenti = {}
                    this.indicatori.forEach( i => {
                        if(i.Tipo__c == 'Piatto') {
                            voti[i.Descrizione__c] = -1
                            commenti[i.Descrizione__c] = ''
                        }
                    })
                    piatto['voti'] = voti
                    piatto['commenti'] = commenti
                    piatto['listaVoti'] = []
                    piatto['media'] = 0
                }
                
                this.esame = esame;
                this.piatti = piatti;
            } catch (error) {
                console.error('Error fetching esame:', error);
            }
        },
        backRoute(){
            this.$router.push('esami')
        }
    }
}
</script>
<style>
.test{
    float: left;
}
</style>